import { createAction, props } from "@ngrx/store";
import { DeductEmotesCountInFireBase } from "./emotes.state";

export const loadEmotesAction = createAction(
    '[GamePage] LOAD_EMOTES',
);

export const emotesLoadedAction = createAction(
    '[GamePage] EMOTES_LOADED',
    props<{
        emojis: any;
    }>()
);

export const emotesCountUpdateAction = createAction(
    '[GamePage] EMOJI_COUNT_UPDATE',
    props<{
        count: number
    }>()
);

export const emotesCountResetAction = createAction(
    '[GamePage] EMOJI_COUNT_RESET',
    (count: number = 0) => ({
        count,
    })
);

export const deductEmotesCountInFireBase = createAction(
    '[GamePage] EMOJI_COUNT_DEDUCTION_IN_FIREBASE',
    props<{
        data: DeductEmotesCountInFireBase;
    }>()
);
